<form class="popupForm" style="min-height: 300px;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      {{'play_conf_popup_title' | GetLabelPipe}}
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important; min-height: 300px;">
      <app-user-details-component [viewID]="1153" [popupMode]="true"></app-user-details-component>
    </mat-dialog-content>
  </div>
</form>
